import { z } from 'zod'

import { FormError } from '@forto-dev/platform-localisation'

export const LoginFormSchema = z.object({
  email: z.string().email(FormError.EMAIL),
  password: z.string().min(8, FormError.MIN_PASSWORD).max(50, FormError.MAX_PASSWORD),
})

export type LoginFormSchemaType = z.infer<typeof LoginFormSchema>
